module.exports = __webpack_public_path__ + "static/media/Wildcat2 1c.1cc5e93d.svg";